import { render, staticRenderFns } from "./specsDialog.vue?vue&type=template&id=96f9416e&"
import script from "./specsDialog.vue?vue&type=script&lang=js&"
export * from "./specsDialog.vue?vue&type=script&lang=js&"
import style0 from "./specsDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports